// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { fantom as _fantom } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the fantom chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 250
 * Chain Name: Fantom
 * Default Block Explorer: https://ftmscan.com
 * Default RPC URL: https://rpc.ankr.com/fantom
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { fantom } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: fantom,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const fantom = createCommon({
	..._fantom,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
